import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/EditOutlined";
import { IconButton } from "@mui/material";
import type { SetStateAction } from "react";
import type { ControllerRenderProps, FieldValues, UseFormReset } from "react-hook-form";

export interface IContactFormActionButtonsProps<T extends FieldValues> {
  open: boolean;
  setOpen: (value: SetStateAction<boolean>) => void;
  onChange: ControllerRenderProps<T>["onChange"];
  reset: UseFormReset<{
    firstName?: string | undefined;
    lastName?: string | undefined;
    job?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
  }>;
}

export const ContactFormActionButtons = <T extends FieldValues>({
  setOpen,
  open,
  onChange,
  reset,
}: IContactFormActionButtonsProps<T>) => {
  return [
    <IconButton key={0} size="small" onClick={() => setOpen(true)} disabled={open}>
      <EditIcon color="primary" />
    </IconButton>,
    <IconButton
      key={1}
      size="small"
      onClick={() => {
        onChange(null);
        reset();
        setOpen(false);
      }}
    >
      <DeleteIcon color="primary" />
    </IconButton>,
  ];
};
